(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorDetailController', MonitorDetailController);

    MonitorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Monitor'];

    function MonitorDetailController($scope, $rootScope, $stateParams, previousState, entity, Monitor) {
        var vm = this;

        vm.monitor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:monitorUpdate', function(event, result) {
            vm.monitor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
